import React from 'react';

const Terms = () => {
  return (
    <div style={{ maxWidth: '800px', margin: '0 auto', padding: '20px', lineHeight: '1.6' }}>
      <h1>서비스 이용약관</h1>

      <div style={{ marginBottom: '30px' }}>
        <p><strong>최종 수정일: 2025년 9월 26일</strong></p>
      </div>

      <section style={{ marginBottom: '30px' }}>
        <h2>제1조 (목적)</h2>
        <p>이 약관은 도토리 저금통(Acorn Bank, 이하 "서비스 제공자")이 제공하는 가족용 미션 기반 용돈 관리 서비스(이하 "서비스")의 이용과 관련하여 서비스 제공자와 이용자간의 권리, 의무 및 책임사항, 기타 필요한 사항을 규정함을 목적으로 합니다.</p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2>제2조 (정의)</h2>
        <ul>
          <li><strong>"서비스"</strong>란 서비스 제공자가 제공하는 가족용 미션 관리 및 용돈 정산 플랫폼을 의미합니다.</li>
          <li><strong>"이용자"</strong>란 이 약관에 따라 회사와 이용계약을 체결하고 서비스를 이용하는 자를 의미합니다.</li>
          <li><strong>"부모"</strong>란 가족 계정을 생성하고 관리하는 성인 이용자를 의미합니다.</li>
          <li><strong>"자녀"</strong>란 부모에 의해 등록된 미성년자 이용자를 의미합니다.</li>
          <li><strong>"미션"</strong>란 부모가 설정한 일일/주간 과제를 의미합니다.</li>
          <li><strong>"도토리"</strong>란 서비스 내에서 사용되는 포인트 단위(1도토리=1원)를 의미합니다.</li>
        </ul>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2>제3조 (약관의 효력과 변경)</h2>
        <p>1. 이 약관은 서비스를 이용하고자 하는 모든 이용자에게 그 효력이 발생합니다.</p>
        <p>2. 서비스 제공자는 필요한 경우 이 약관을 변경할 수 있으며, 변경된 약관은 서비스 내 공지사항을 통해 공지합니다.</p>
        <p>3. 변경된 약관에 동의하지 않는 경우, 서비스 이용을 중단하고 탈퇴할 수 있습니다.</p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2>제4조 (서비스의 제공 및 변경)</h2>
        <p>1. 서비스 제공자는 다음과 같은 서비스를 제공합니다:</p>
        <ul>
          <li>가족 구성원 관리</li>
          <li>미션 생성 및 관리</li>
          <li>미션 수행 체크 및 승인</li>
          <li>도토리(포인트) 적립 및 정산</li>
          <li>보상 교환 시스템</li>
          <li>활동 기록 및 통계</li>
        </ul>
        <p>2. 서비스 제공자는 운영상, 기술상의 필요에 따라 제공하고 있는 서비스를 변경할 수 있습니다.</p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2>제5조 (이용계약의 성립)</h2>
        <p>1. 이용계약은 이용자가 이 약관에 동의하고 서비스 제공자가 정한 절차에 따라 가입신청을 하여 서비스 제공자가 이를 승낙함으로써 성립합니다.</p>
        <p>2. 부모는 유효한 이메일 주소와 비밀번호로 회원가입을 합니다.</p>
        <p>3. 자녀는 부모의 동의 하에 이름과 PIN을 통해 서비스를 이용합니다.</p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2>제6조 (개인정보보호)</h2>
        <p>서비스 제공자는 관계 법령이 정하는 바에 따라 이용자의 개인정보를 보호하기 위해 노력합니다. 개인정보의 보호 및 사용에 대해서는 관련 법령 및 서비스 제공자의 개인정보처리방침이 적용됩니다.</p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2>제7조 (이용자의 의무)</h2>
        <p>1. 이용자는 다음 행위를 하여서는 안 됩니다:</p>
        <ul>
          <li>타인의 정보를 도용하는 행위</li>
          <li>서비스의 안전성을 해치는 행위</li>
          <li>다른 이용자의 개인정보를 수집, 저장, 공개하는 행위</li>
          <li>미성년자에게 해로운 내용의 정보를 전송하는 행위</li>
          <li>서비스와 관련된 설비의 오동작이나 정보 등의 파괴 및 혼란을 유발하는 행위</li>
        </ul>
        <p>2. 부모는 자녀의 서비스 이용에 대해 책임을 집니다.</p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2>제8조 (서비스 이용제한)</h2>
        <p>서비스 제공자는 이용자가 이 약관의 의무를 위반하거나 서비스의 정상적인 운영을 방해한 경우, 경고, 일시정지, 영구이용정지 등으로 서비스 이용을 단계적으로 제한할 수 있습니다.</p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2>제9조 (책임제한)</h2>
        <p>1. 서비스 제공자는 천재지변 또는 이에 준하는 불가항력으로 인하여 서비스를 제공할 수 없는 경우에는 서비스 제공에 관한 책임이 면제됩니다.</p>
        <p>2. 서비스 제공자는 이용자의 귀책사유로 인한 서비스 이용의 장애에 대하여는 책임을 지지 않습니다.</p>
        <p>3. 서비스 제공자는 이용자가 서비스를 이용하여 기대하는 수익을 상실한 것에 대하여 책임을 지지 않습니다.</p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2>제10조 (준거법 및 관할법원)</h2>
        <p>1. 이 약관 및 서비스 제공자와 이용자간의 서비스 이용계약에는 대한민국 법을 적용합니다.</p>
        <p>2. 서비스 이용과 관련하여 회사와 이용자간에 분쟁이 발생한 경우, 관련 법령에 정한 절차에 따라 조정을 신청하거나 회사의 본사 소재지를 관할하는 법원에 소송을 제기할 수 있습니다.</p>
      </section>

      <section>
        <p><strong>부칙</strong></p>
        <p>본 약관은 2025년 9월 26일부터 적용됩니다.</p>
      </section>
    </div>
  );
};

export default Terms;